import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

export default function Notice() {
  const { t } = useI18n();
  return (
    <section
      id="notice"
      className="relative py-16 md:py-20"
      style={{ background: "#FEF6E4" }}
      data-testid="important-notice-section"
    >
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[22px] border border-[#F1B24A] bg-[#FFF7E1] p-7 md:p-10 overflow-hidden"
        >
          <div className="absolute top-0 left-0 h-full w-1.5 bg-[#D48806]" />
          <div className="flex flex-col md:flex-row gap-6 md:gap-10">
            <div className="shrink-0 flex md:flex-col items-center md:items-start gap-4">
              <div className="w-14 h-14 rounded-full bg-[#D48806] text-[#FFF7E1] flex items-center justify-center">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                  <path d="M12 3l10 18H2L12 3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                  <path d="M12 10v5M12 18v.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                </svg>
              </div>
              <div>
                <div className="font-mono-caption text-[10px] tracking-[0.2em] uppercase text-[#8A5A00] mb-1">
                  {t.notice.chip}
                </div>
                <div className="font-display text-2xl md:text-[1.7rem] leading-tight text-[#3C2500]">
                  {t.notice.title_a}
                  <br />
                  <span className="font-editorial-italic">{t.notice.title_italic}</span>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <p className="text-[14.5px] md:text-[15px] leading-[1.75] text-[#3C2500]">
                {t.notice.body}
              </p>
              <div className="mt-6 flex flex-wrap gap-2 text-[11px]">
                {t.notice.chips.map((c) => (
                  <span
                    key={c}
                    className="rounded-full bg-[#3C2500] text-[#FFF7E1] px-3 py-1 font-mono-caption tracking-[0.12em] uppercase"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
